import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Identificar el ciclo (sin culpa)",
    opening: localizedGenderNode(
      [
      "Hoy no juzgo. Reconozco el patrón: perseguir–alejarse."
    ],
      [
      "Hoy no juzgo. Reconozco el patrón: perseguir–alejarse."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Esto es un patrón. No estoy roto/a”.",
      "Mindfulness breve:",
      "Observo: ¿ahora me acerco con ansiedad o me alejo?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Esto es un patrón. No estoy roto/a”.",
      "Mindfulness breve:",
      "Observo: ¿ahora me acerco con ansiedad o me alejo?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿En qué momentos me convierto en “perseguidor/a”? ¿Y en cuáles en “evitador/a”?\n[Escribe aquí]",
      "¿Cuál es el disparador más común que activa el ciclo entre nosotros?\n[Escribe aquí]",
      "¿Qué hago inmediatamente cuando el patrón se activa? (teléfono / tono / silencio / reproche)\n[Escribe aquí]"
    ],
      [
      "¿En qué momentos me convierto en “perseguidor/a”? ¿Y en cuáles en “evitador/a”?\n[Escribe aquí]",
      "¿Cuál es el disparador más común que activa el ciclo entre nosotros?\n[Escribe aquí]",
      "¿Qué hago inmediatamente cuando el patrón se activa? (teléfono / tono / silencio / reproche)\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Hoy reconozco el ciclo. Reconocer es el comienzo de la libertad."
    ],
      [
      "Cierre",
      "Hoy reconozco el ciclo. Reconocer es el comienzo de la libertad."
    ]
    ),
    action: localizedGenderNode(
      "Una vez hoy, cuando comience — hago una “pausa de 20 segundos”: una respiración + la frase interna: “Esto es el ciclo”.",
      "Una vez hoy, cuando comience — hago una “pausa de 20 segundos”: una respiración + la frase interna: “Esto es el ciclo”."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Lo que realmente busca el perseguidor",
    opening: localizedGenderNode(
      [
      "Hoy descubro que perseguir busca seguridad, no ganar."
    ],
      [
      "Hoy descubro que perseguir busca seguridad, no ganar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Busco cercanía, no pelea”.",
      "Mindfulness breve:",
      "Me pregunto: ¿qué necesidad hay debajo del impulso?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Busco cercanía, no pelea”.",
      "Mindfulness breve:",
      "Me pregunto: ¿qué necesidad hay debajo del impulso?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando “persigo”, ¿qué intento obtener? (paz / tranquilidad / respuesta / amor)\n[Escribe aquí]",
      "¿Qué es lo que más temo si no hay respuesta?\n[Escribe aquí]",
      "¿Cuál sería una frase limpia que me gustaría decir en lugar de insistir?\n[Escribe aquí]"
    ],
      [
      "Cuando “persigo”, ¿qué intento obtener? (paz / tranquilidad / respuesta / amor)\n[Escribe aquí]",
      "¿Qué es lo que más temo si no hay respuesta?\n[Escribe aquí]",
      "¿Cuál sería una frase limpia que me gustaría decir en lugar de insistir?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando la necesidad es clara, el tono se calma."
    ],
      [
      "Cierre",
      "Cuando la necesidad es clara, el tono se calma."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una frase limpia: “Necesito __ ahora” (sin reproche).",
      "Escribo una frase limpia: “Necesito __ ahora” (sin reproche)."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Lo que realmente protege el alejamiento",
    opening: localizedGenderNode(
      [
      "Hoy entiendo que alejarme es protección, no crueldad."
    ],
      [
      "Hoy entiendo que alejarme es protección, no crueldad."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Mi distancia intenta protegerme”.",
      "Mindfulness breve:",
      "Observo: ¿mi cuerpo entra en modo apagado?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Mi distancia intenta protegerme”.",
      "Mindfulness breve:",
      "Observo: ¿mi cuerpo entra en modo apagado?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Cuando “me voy”, ¿de qué intento protegerme? (crítica / saturación / control / fracaso)\n[Escribe aquí]",
      "¿Cómo se siente mi cuerpo justo cuando me alejo?\n[Escribe aquí]",
      "¿Qué necesitaba escuchar para quedarme un minuto más?\n[Escribe aquí]"
    ],
      [
      "Cuando “me voy”, ¿de qué intento protegerme? (crítica / saturación / control / fracaso)\n[Escribe aquí]",
      "¿Cómo se siente mi cuerpo justo cuando me alejo?\n[Escribe aquí]",
      "¿Qué necesitaba escuchar para quedarme un minuto más?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Alejarse no siempre significa “no me importa”. A veces significa “es demasiado”."
    ],
      [
      "Cierre",
      "Alejarse no siempre significa “no me importa”. A veces significa “es demasiado”."
    ]
    ),
    action: localizedGenderNode(
      "Cuando quiera desaparecer — digo una frase corta: “Estoy saturado/a. Necesito 10 minutos”.",
      "Cuando quiera desaparecer — digo una frase corta: “Estoy saturado/a. Necesito 10 minutos”."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Los disparadores: qué enciende el ciclo",
    opening: localizedGenderNode(
      [
      "Hoy identifico los puntos que encienden el patrón."
    ],
      [
      "Hoy identifico los puntos que encienden el patrón."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Si reconozco el disparador, me atrapa menos”.",
      "Mindfulness breve:",
      "Observo la primera señal corporal antes de reaccionar."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Si reconozco el disparador, me atrapa menos”.",
      "Mindfulness breve:",
      "Observo la primera señal corporal antes de reaccionar."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "3 disparadores principales que activan el ciclo:\n[Escribe aquí]",
      "¿Cuál está ligado al miedo al abandono?\n[Escribe aquí]",
      "¿Cuál está ligado al miedo a perderme a mí mismo/a?\n[Escribe aquí]"
    ],
      [
      "3 disparadores principales que activan el ciclo:\n[Escribe aquí]",
      "¿Cuál está ligado al miedo al abandono?\n[Escribe aquí]",
      "¿Cuál está ligado al miedo a perderme a mí mismo/a?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un disparador es una señal de alerta, no una condena."
    ],
      [
      "Cierre",
      "Un disparador es una señal de alerta, no una condena."
    ]
    ),
    action: localizedGenderNode(
      "Elijo un disparador y le agrego una frase ancla: “Pausa. Esto es un disparador”.",
      "Elijo un disparador y le agrego una frase ancla: “Pausa. Esto es un disparador”."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "El cuerpo en lugar de la guerra",
    opening: localizedGenderNode(
      [
      "Hoy vuelvo al cuerpo para no incendiar el conflicto."
    ],
      [
      "Hoy vuelvo al cuerpo para no incendiar el conflicto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Tres respiraciones lentas.",
      "Mindfulness breve:",
      "Relajo hombros, aflojo mandíbula, suavizo el abdomen."
    ],
      [
      "Me detengo conmigo.",
      "Tres respiraciones lentas.",
      "Mindfulness breve:",
      "Relajo hombros, aflojo mandíbula, suavizo el abdomen."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Dónde se tensa mi cuerpo durante un conflicto?\n[Escribe aquí]",
      "¿Qué me ayuda a bajar la tensión un 10%? (caminar / agua / música / ducha)\n[Escribe aquí]",
      "¿Qué señal temprana me dice “voy a explotar / desaparecer”?\n[Escribe aquí]"
    ],
      [
      "¿Dónde se tensa mi cuerpo durante un conflicto?\n[Escribe aquí]",
      "¿Qué me ayuda a bajar la tensión un 10%? (caminar / agua / música / ducha)\n[Escribe aquí]",
      "¿Qué señal temprana me dice “voy a explotar / desaparecer”?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando calmo el cuerpo, cuido el vínculo."
    ],
      [
      "Cierre",
      "Cuando calmo el cuerpo, cuido el vínculo."
    ]
    ),
    action: localizedGenderNode(
      "Ante un disparador: agua + una respiración antes de hablar.",
      "Ante un disparador: agua + una respiración antes de hablar."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Pedido en lugar de exigencia",
    opening: localizedGenderNode(
      [
      "Hoy transformo presión en pedido."
    ],
      [
      "Hoy transformo presión en pedido."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Un pedido acerca. Una exigencia aleja”.",
      "Mindfulness breve:",
      "Reviso: ¿vengo a recibir o a corregir?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Un pedido acerca. Una exigencia aleja”.",
      "Mindfulness breve:",
      "Reviso: ¿vengo a recibir o a corregir?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué exigencia suelo expresar?\n[Escribe aquí]",
      "¿Cómo suena como pedido breve y claro?\n[Escribe aquí]",
      "¿Qué estoy dispuesto/a a aceptar aunque no sea perfecto?\n[Escribe aquí]"
    ],
      [
      "¿Qué exigencia suelo expresar?\n[Escribe aquí]",
      "¿Cómo suena como pedido breve y claro?\n[Escribe aquí]",
      "¿Qué estoy dispuesto/a a aceptar aunque no sea perfecto?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un buen pedido deja espacio para responder."
    ],
      [
      "Cierre",
      "Un buen pedido deja espacio para responder."
    ]
    ),
    action: localizedGenderNode(
      "Escribo un “pedido dorado”: corto, específico, sin pasado.",
      "Escribo un “pedido dorado”: corto, específico, sin pasado."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Un espacio seguro para hablar (10 minutos)",
    opening: localizedGenderNode(
      [
      "Hoy practico hablar sin activar el ciclo."
    ],
      [
      "Hoy practico hablar sin activar el ciclo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Quiero conexión, no ganar”.",
      "Mindfulness breve:",
      "Cuido el tono: lento, bajo, frases cortas."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Quiero conexión, no ganar”.",
      "Mindfulness breve:",
      "Cuido el tono: lento, bajo, frases cortas."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué tema quiero hablar sin desbordarme?\n[Escribe aquí]",
      "¿Cuál es la frase inicial más limpia que puedo decir?\n[Escribe aquí]",
      "¿Qué límite de tiempo me cuida en una conversación?\n[Escribe aquí]"
    ],
      [
      "¿Qué tema quiero hablar sin desbordarme?\n[Escribe aquí]",
      "¿Cuál es la frase inicial más limpia que puedo decir?\n[Escribe aquí]",
      "¿Qué límite de tiempo me cuida en una conversación?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una charla breve y clara vale más que una noche entera de ciclo."
    ],
      [
      "Cierre",
      "Una charla breve y clara vale más que una noche entera de ciclo."
    ]
    ),
    action: localizedGenderNode(
      "Si hay charla: “solo 10 minutos” + una pausa a mitad para respirar.",
      "Si hay charla: “solo 10 minutos” + una pausa a mitad para respirar."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Reparar después del disparador",
    opening: localizedGenderNode(
      [
      "Hoy aprendo a reparar rápido, no a castigarme días."
    ],
      [
      "Hoy aprendo a reparar rápido, no a castigarme días."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Reparar es posible, incluso si fue difícil”.",
      "Mindfulness breve:",
      "Me pregunto: ¿cuál fue mi parte sin vergüenza?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Reparar es posible, incluso si fue difícil”.",
      "Mindfulness breve:",
      "Me pregunto: ¿cuál fue mi parte sin vergüenza?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué hice que encendió el ciclo?\n[Escribe aquí]",
      "¿Qué haría distinto con 10% menos intensidad?\n[Escribe aquí]",
      "¿Cuál es una frase breve de reparación que me representa?\n[Escribe aquí]"
    ],
      [
      "¿Qué hice que encendió el ciclo?\n[Escribe aquí]",
      "¿Qué haría distinto con 10% menos intensidad?\n[Escribe aquí]",
      "¿Cuál es una frase breve de reparación que me representa?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Reparar es fortaleza, no debilidad."
    ],
      [
      "Cierre",
      "Reparar es fortaleza, no debilidad."
    ]
    ),
    action: localizedGenderNode(
      "Preparo una frase de reparación y la dejo lista.",
      "Preparo una frase de reparación y la dejo lista."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Un “time-out” sano",
    opening: localizedGenderNode(
      [
      "Hoy distingo entre pausa y abandono."
    ],
      [
      "Hoy distingo entre pausa y abandono."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “La pausa es un puente, no una huida”.",
      "Mindfulness breve:",
      "Observo: ¿pido espacio con respeto?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “La pausa es un puente, no una huida”.",
      "Mindfulness breve:",
      "Observo: ¿pido espacio con respeto?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo necesito una pausa para no explotar / desaparecer?\n[Escribe aquí]",
      "¿Cómo pido una pausa sin amenazar? (una frase)\n[Escribe aquí]",
      "¿A qué hora me comprometo a volver?\n[Escribe aquí]"
    ],
      [
      "¿Cuándo necesito una pausa para no explotar / desaparecer?\n[Escribe aquí]",
      "¿Cómo pido una pausa sin amenazar? (una frase)\n[Escribe aquí]",
      "¿A qué hora me comprometo a volver?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Espacio con hora de regreso = seguridad."
    ],
      [
      "Cierre",
      "Espacio con hora de regreso = seguridad."
    ]
    ),
    action: localizedGenderNode(
      "Escribo la “fórmula de pausa”: “Necesito 20 minutos, vuelvo a las __”.",
      "Escribo la “fórmula de pausa”: “Necesito 20 minutos, vuelvo a las __”."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Los miedos bajo el ciclo",
    opening: localizedGenderNode(
      [
      "Hoy contacto los miedos que nos activan."
    ],
      [
      "Hoy contacto los miedos que nos activan."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “El miedo quiere cuidado, no guerra”.",
      "Mindfulness breve:",
      "Observo qué miedo domina: abandono o invasión."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “El miedo quiere cuidado, no guerra”.",
      "Mindfulness breve:",
      "Observo qué miedo domina: abandono o invasión."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Mi miedo principal en la relación es: _\n[Escribe aquí]",
      "¿Qué hago cuando aparece el miedo?\n[Escribe aquí]",
      "¿Qué verdad suave puedo decirme cuando surge?\n[Escribe aquí]"
    ],
      [
      "Mi miedo principal en la relación es: _\n[Escribe aquí]",
      "¿Qué hago cuando aparece el miedo?\n[Escribe aquí]",
      "¿Qué verdad suave puedo decirme cuando surge?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Cuando veo el miedo, reacciono menos."
    ],
      [
      "Cierre",
      "Cuando veo el miedo, reacciono menos."
    ]
    ),
    action: localizedGenderNode(
      "Frase ancla: “Esto es miedo. No tiene que guiar mi acción”.",
      "Frase ancla: “Esto es miedo. No tiene que guiar mi acción”."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Límites y necesidades (sin guerra)",
    opening: localizedGenderNode(
      [
      "Hoy expreso una necesidad y un límite con respeto."
    ],
      [
      "Hoy expreso una necesidad y un límite con respeto."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Puedo ser claro/a y amable”.",
      "Mindfulness breve:",
      "Me pregunto: ¿qué necesito para sentirme seguro/a?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Puedo ser claro/a y amable”.",
      "Mindfulness breve:",
      "Me pregunto: ¿qué necesito para sentirme seguro/a?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Una necesidad que suelo ocultar:\n[Escribe aquí]",
      "Un límite que necesito para no agotarme:\n[Escribe aquí]",
      "¿Cómo lo digo en primera persona, sin acusar?\n[Escribe aquí]"
    ],
      [
      "Una necesidad que suelo ocultar:\n[Escribe aquí]",
      "Un límite que necesito para no agotarme:\n[Escribe aquí]",
      "¿Cómo lo digo en primera persona, sin acusar?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite protege, no castiga."
    ],
      [
      "Cierre",
      "Un límite protege, no castiga."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una frase de límite clara y corta.",
      "Escribo una frase de límite clara y corta."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Qué es correcto para mí en esta relación",
    opening: localizedGenderNode(
      [
      "Hoy reviso compatibilidad, no solo miedo."
    ],
      [
      "Hoy reviso compatibilidad, no solo miedo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “No solo reacciono: elijo”.",
      "Mindfulness breve:",
      "Me pregunto: ¿me siento más yo o menos yo aquí?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “No solo reacciono: elijo”.",
      "Mindfulness breve:",
      "Me pregunto: ¿me siento más yo o menos yo aquí?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué sí funciona en esta relación?\n[Escribe aquí]",
      "¿Qué no funciona una y otra vez?\n[Escribe aquí]",
      "¿Qué necesitaría cambiar para que el ciclo se calme?\n[Escribe aquí]"
    ],
      [
      "¿Qué sí funciona en esta relación?\n[Escribe aquí]",
      "¿Qué no funciona una y otra vez?\n[Escribe aquí]",
      "¿Qué necesitaría cambiar para que el ciclo se calme?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Ver la verdad no destruye, ilumina."
    ],
      [
      "Cierre",
      "Ver la verdad no destruye, ilumina."
    ]
    ),
    action: localizedGenderNode(
      "Escribo un cambio pequeño que pido de forma limpia.",
      "Escribo un cambio pequeño que pido de forma limpia."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Un pequeño “contrato” contra el ciclo",
    opening: localizedGenderNode(
      [
      "Hoy creo un plan simple que reemplace el automático."
    ],
      [
      "Hoy creo un plan simple que reemplace el automático."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Constancia supera drama”.",
      "Mindfulness breve:",
      "¿Qué acción mínima rompe el patrón?"
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Constancia supera drama”.",
      "Mindfulness breve:",
      "¿Qué acción mínima rompe el patrón?"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuál es nuestro disparador principal?\n[Escribe aquí]",
      "¿Cuál será el nuevo primer paso en lugar de perseguir/huir?\n[Escribe aquí]",
      "¿Qué frase interna usaré cuando se active?\n[Escribe aquí]"
    ],
      [
      "¿Cuál es nuestro disparador principal?\n[Escribe aquí]",
      "¿Cuál será el nuevo primer paso en lugar de perseguir/huir?\n[Escribe aquí]",
      "¿Qué frase interna usaré cuando se active?\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un patrón cambia con un movimiento pequeño repetido."
    ],
      [
      "Cierre",
      "Un patrón cambia con un movimiento pequeño repetido."
    ]
    ),
    action: localizedGenderNode(
      "Escribo un contrato interno de una línea: “Cuando _, hago _”.",
      "Escribo un contrato interno de una línea: “Cuando _, hago _”."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave: elegirme dentro de la relación",
    opening: localizedGenderNode(
      [
      "Hoy no necesito ser perfecto/a. Me soy leal."
    ],
      [
      "Hoy no necesito ser perfecto/a. Me soy leal."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración profunda. “Elijo conexión sin perderme”.",
      "Mindfulness breve:",
      "Reconozco que lo esencial es el respeto propio."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración profunda. “Elijo conexión sin perderme”.",
      "Mindfulness breve:",
      "Reconozco que lo esencial es el respeto propio."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mí en este recorrido?\n[Escribe aquí]",
      "¿Qué tengo más claro ahora sobre nuestro patrón?\n[Escribe aquí]",
      "Frase de regreso para días difíciles:\n[Escribe aquí]"
    ],
      [
      "¿Qué aprendí sobre mí en este recorrido?\n[Escribe aquí]",
      "¿Qué tengo más claro ahora sobre nuestro patrón?\n[Escribe aquí]",
      "Frase de regreso para días difíciles:\n[Escribe aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del recorrido",
      "No soy solo “el perseguidor” ni solo “el evitador”.",
      "Soy una persona buscando seguridad y amor.",
      "Hoy aprendo a pausar, respirar y elegir mi respuesta.",
      "Y eso es fortaleza."
    ],
      [
      "Cierre final del recorrido",
      "No soy solo “el perseguidor” ni solo “el evitador”.",
      "Soy una persona buscando seguridad y amor.",
      "Hoy aprendo a pausar, respirar y elegir mi respuesta.",
      "Y eso es fortaleza."
    ]
    ),
    action: localizedGenderNode(
      "Elijo una acción que simbolice cambio: un mensaje limpio / una pausa bien dicha / un pedido claro.",
      "Elijo una acción que simbolice cambio: un mensaje limpio / una pausa bien dicha / un pedido claro."
    ),
  },
].map(buildNormalizedDay);

export const pursuerDistancerCycleBlueprintEs = buildNormalizedPilotBlueprint({
  id: "pursuer_distancer_cycle_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "pursuer_distancer_cycle",
  category: "general",
  journeyName: {
    he: "מעגל רודף–נמנע",
    en: "Pursuer–Distancer Cycle",
    es: "Ciclo Perseguidor–Evitador",
  },
  days,
});

export default pursuerDistancerCycleBlueprintEs;
